import { api } from '../client'
import type { MetadataVisibility } from '../metadata/types'
import type {
  UserAssignee,
  UserFavoriteResponse,
  UserInitial,
  UserReviewer,
} from './types'

export async function fetchInitialPermissions() {
  const { data } = await api.get<UserInitial>('/users/initial')
  return data
}

export async function fetchReviewers(visibility?: MetadataVisibility) {
  const { data } = await api.get<UserReviewer[]>('/users/reviewers', {
    params: {
      visibility,
    },
  })
  return data
}

export async function fetchEditors() {
  const { data } = await api.get<UserReviewer[]>('/users/editors')
  return data
}

export async function fetchAssignees() {
  const { data } = await api.get<UserAssignee[]>('/users/assignees')
  return data
}

export async function fetchEmployeeGroups() {
  const { data } = await api.get<string[]>('/users/employeegroups')
  return data
}

export async function addFavorite(email: string) {
  const { data } = await api.post<UserFavoriteResponse>('/users/favorites', {
    email,
  })
  return data
}

export async function removeFavorite(email: string) {
  const { data } = await api.delete<UserFavoriteResponse>('/users/favorites', {
    params: { email },
  })
  return data
}
